//从字符截取数字
const getMidNum: Function = (str: string, start: number, len: number) => {
  if (start + len > 0) {
    return +str.substr(start < 0 ? 0 : start, start < 0 ? start + len : len);
  } else {
    return 0;
  }
};
//比较两个大整数的大小，返回－1，0，1
const bigNumCompare: Function = (a: string, b: string) => {
  let back = 0;
  const max = Math.ceil(Math.max(a.length, b.length) / 15);
  //分成多少段,从左边开始
  for (let i = max; i > 0; i--) {
    const num1 = getMidNum(a, a.length - i * 15, 15);
    const num2 = getMidNum(b, b.length - i * 15, 15);
    //15位数字相减
    const cur = num1 - num2;
    if (cur < 0) {
      back = -1;
      break;
    } else if (cur > 0) {
      back = 1;
      break;
    }
  }
  return back;
};
/*js分治算法实现大整数相加,算法复杂度为O(n/15)
 *   1、整数的精度是Math.pow(2,53),大于 9007199254740992 的可能会丢失精度,所以相加的字符长度为15位。
 *   2、负数＋负数、负数＋正数、正数＋负数的情况
 * */
const bigNumAdd: Function = (a: string, b: string) => {
  if (a[0] === "-" && b[0] === "-") {
    return "－" + bigNumAdd(a.substr(1), b.substr(1));
  } else if (a[0] === "-") {
    return bigNumSub(b, a.substr(1));
  } else if (b[0] === "-") {
    return bigNumSub(a, b.substr(1));
  }
  let res = "";
  let temp = 0;

  const len1 = a.length;
  const len2 = b.length;
  const n = Math.ceil(Math.max(len1, len2) / 15);
  //分成多少段
  for (let i = 1; i < n + 1; i++) {
    const num1 = getMidNum(a, len1 - i * 15, 15);
    const num2 = getMidNum(b, len2 - i * 15, 15);
    //15位数字相加
    let strTemp = String(temp + num1 + num2);

    if (i !== n) {
      //异常1:处理000000000000000＋整数的异常情况
      if (strTemp.length < 15) {
        strTemp = "0".repeat(15 - strTemp.length) + strTemp;
        res = strTemp + res;
        temp = 0;
        continue;
      }
      //异常2:15位相加等于16位
      if (strTemp.length === 16) {
        res = strTemp.substr(1, 15) + res;
        temp = 1;
        continue;
      }
    }
    //相加后的结果放入res前面
    res = strTemp + res;
    temp = 0;
  }
  return res;
};

//大整数相减，处理 负数-负数、负数－正数、正数－负数的情况
const bigNumSub: Function = (a: string, b: string) => {
  if (a[0] === "-" && b[0] === "-") {
    return bigNumSub(b.substr(1), a.substr(1));
  } else if (a[0] === "-") {
    return "-" + bigNumAdd(a.substr(1), b);
  } else if (b[0] === "-") {
    return bigNumAdd(a, b.substr(1));
  }
  let symb = "";
  if (bigNumCompare(a, b) < 0) {
    symb = "-";
    const cache = a;
    a = b;
    b = cache;
  }
  let res = "";
  let temp = 0;
  const len = 15;
  let maxZore = "1";
  for (let i = 0; i < len; i++) {
    maxZore += "0";
  }
  const n = Math.ceil(a.length / len);
  //分成多少段
  for (let i = 1; i < n + 1; i++) {
    const num1 = getMidNum(a, a.length - i * len, len);
    const num2 = getMidNum(b, b.length - i * len, len);
    //15位数字相减
    let tempNum = num1 - num2 - temp;
    if (tempNum < 0) {
      temp = 1;
      tempNum = parseInt(maxZore) + tempNum;
    } else {
      temp = 0;
    }
    let strTemp = String(tempNum);

    if (i !== n) {
      //异常1:处理000000000000000＋整数的异常情况
      if (strTemp.length < len) {
        strTemp = "0".repeat(len - strTemp.length) + strTemp;
      }
    }
    //相加后的结果放入res前面
    res = strTemp + res;
  }
  return symb + res;
};

export default bigNumSub;
